import { ProductStateType } from "@/util/constants";
import { defineOutOfStock } from "@/helpers/product-manager";
import { stockType as productStockType } from "@/constants/product-stock";

export type HasPropertyType = "onRequest" | "noPrice" | "outOfStock" | "hasPrice" | "inStock";

export interface HasPropertyProps {
  price: [number, number];
  state: number;
  stockType: string;
  isHidePriceIfProductIsOutOfStock: boolean;
  deliveryStandardTimesIsNotDefined: boolean;
}

export const useProductElement = (props: HasPropertyProps) => {
  const { price, state, stockType, isHidePriceIfProductIsOutOfStock, deliveryStandardTimesIsNotDefined } = props;
  const hasProperty = (type: HasPropertyType): boolean => {
    const hasPrice = !!(price.length && !!price[0] && !!price[1]);

    switch (type) {
      case "onRequest":
        return state === ProductStateType.OnRequest;
      case "noPrice":
        return !hasPrice;
      case "outOfStock":
        return defineOutOfStock({
          hasPrice,
          isHidePriceIfProductIsOutOfStock,
          deliveryStandardTimesIsNotDefined,
          stockType,
          productState: state,
        });
      case "hasPrice":
        return hasPrice;
      case "inStock":
        return [productStockType.localStock, productStockType.localDistributorStock].includes(stockType);
      default:
        return false;
    }
  };

  return {
    hasProperty,
  };
};
